import {LocalStorageKey, LocalStorageManagement} from "@/libs/LocalStorage";


function noRemoveCache() {
  // 白名单
  const list = [LocalStorageKey.phoneMemo,LocalStorageKey.isAnimationFinished];

  const cache: any = {};
  list.map((value) => {
    const key = value;
    const val = localStorage.getItem(key) || false;
    if (val) {
      cache[key] = val;
    }
  });

  setTimeout(() => {
    for (let key in cache) {
      if (cache[key]) {
        localStorage.setItem(key, cache[key]);
      }
    }
  }, 0); // 在同步队列里最后执行，恢复数据
}

export async function logout() {
  const phone = new LocalStorageManagement(LocalStorageKey.phone).value;
  if (phone) {
    new LocalStorageManagement(LocalStorageKey.phoneMemo).set(phone);
  }

  noRemoveCache();
  localStorage.clear();

  return Promise.resolve();
}
